import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { eEnrolmentRoutePaths } from '@module/enrolment/config';
import { eBillingRoutePaths } from '@module/billing/config';
import { eEzynessAdminRoutePaths } from '@module/ezyness-admin/config';
import { AuthGuard, PermissionGuard, RedirectGuard } from '@abpdz/ng.core';
import { FuseApplicationLayoutComponent } from '@abpdz/ng.theme.fuse';
import { MaterialApplicationLayoutComponent } from '@abpdz/ng.theme.material';
import { DummyComponent } from './shared/components/dummy.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@abpdz/ng.account').then((m) =>
        m.AccountModule.forLazy({ redirectUrl: '/' })
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: FuseApplicationLayoutComponent,
    children: [
      {
        path: 'account',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@abpdz/ng.account').then((m) =>
            m.AccountModule.forLazy({ redirectUrl: '/' })
          ),
      },
      {
        path: 'identity',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@abpdz/ng.identity').then((m) => m.IdentityModule.forLazy()),
      },
      {
        path: eEnrolmentRoutePaths.Root,
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@module/enrolment').then((m) => m.EnrolmentModule.forLazy()),
      },
      {
        path: 'audit',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@abpdz/ng.audit').then((m) => m.AbpDzAuditModule.forLazy()),
      },
      {
        path: eBillingRoutePaths.Root,
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@module/billing').then((m) => m.BillingModule.forLazy()),
      },
      {
        path: 'clients',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@module/clients').then((m) => m.ClientsModule.forLazy()),
      },
      {
        path: eEzynessAdminRoutePaths.Root,
        canActivate: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('@module/ezyness-admin').then((m) =>
            m.EzynessAdminModule.forLazy()
          ),
      },
      {
        path: 'account',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@abpdz/ng.account').then((m) =>
            m.AccountModule.forLazy({ redirectUrl: '/' })
          ),
      },
      {
        path: 'clientsBoard',
        canActivate: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
        data: { requiredPolicy: 'Enrolment.Clients' }
      },
      {
        path: 'clientsBoardLPR',
        canActivate: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
        data: { isLPR: true, requiredPolicy: 'Enrolment.LPRClients' }
      },
      {
        path: 'clientsBoardSiegeSocial',
        canActivate: [AuthGuard, PermissionGuard],
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
        data: { isSiegeSocial: true, requiredPolicy: 'Enrolment.SiegeSocial' }
      },
      {
        path: '',
        pathMatch: 'full',
        canActivate: [RedirectGuard],
        component: DummyComponent
      },
      {
        path: '**',
        redirectTo: '/',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
